import React from 'react';
import { useScreenInit } from '../useScreenInit';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { CategoryTiles } from '../components/CategoryTiles';
import { Manifesto } from '../components/Manifesto';
import { Footer } from '../components/Footer';
export function Home() {
  useScreenInit();
  return <div className="min-h-screen w-full bg-black text-white" data-id="element-210">
      <Navbar data-id="element-211" />
      <main data-id="element-212">
        <Hero data-id="element-213" />
        <section id="tiles" data-id="element-214">
          <CategoryTiles data-id="element-215" />
        </section>
        <Manifesto data-id="element-216" />
      </main>
      <Footer data-id="element-217" />
    </div>;
}